import Icon from "@galaxy-io/dls/icons/Icon";
import Flex, { FlexDirection } from "@galaxy-io/dls/layout/Flex";
import Link from "@galaxy-io/dls/links/Link";
import DescriptionList from "@galaxy-io/dls/lists/DescriptionList";
import { t } from "@galaxy-io/dls/theme/tokens/t";
import Widget from "@galaxy-io/dls/widget/Widget";
import { styled } from "@linaria/react";
import type { ComponentProps, ReactNode } from "react";
export function DrawerStack({ children }: { children: ReactNode }) {
  return (
    <Flex direction={FlexDirection.COLUMN} gap={16} minWidth={0} shrink={0}>
      {children}
    </Flex>
  );
}
export function DrawerList({ children }: { children: ReactNode }) {
  return (
    <Flex direction={FlexDirection.COLUMN} gap={16} minWidth={0}>
      {children}
    </Flex>
  );
}
export function DrawerExternalLink({
  target,
  rel: _rel,
  ...props
}: ComponentProps<typeof Link> & { target?: string; rel?: string; title?: string }) {
  return <Link {...props} isExternal={target === "_blank"} />;
}
export function DrawerRow({ label, children }: { label: string; children: ReactNode }) {
  return <DescriptionList items={[{ label, value: children }]} />;
}
const Tile = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 40px;
  flex-shrink: 0;
  border-radius: ${t.radius.lg};
  border: 0.5px solid ${t.color.border.primary};
  background: ${t.color.background.secondary};
`;
export function DrawerIcon({ icon }: { icon: ComponentProps<typeof Icon>["component"] }) {
  return (
    <DrawerTile>
      <Icon component={icon} size={22} />
    </DrawerTile>
  );
}
/** The same 40px header tile for leading graphics Icon cannot render — a brand
 * logo, an avatar — so dialogs and drawers keep one header shape. */
export function DrawerTile({ children }: { children: ReactNode }) {
  return <Tile>{children}</Tile>;
}
export function DrawerSection({
  children,
  ...props
}: Omit<
  Extract<ComponentProps<typeof Widget>, { isCollapsible: true }>,
  "isCollapsible" | "isInteractive" | "onClick"
>) {
  return (
    <Widget isCollapsible {...props}>
      {children}
    </Widget>
  );
}
